import { ButtonLinkWithIcon } from '@blueprint/ui';
import styled from '@emotion/styled';

export const NavigationLink = styled(ButtonLinkWithIcon)(`
    padding-left: 0;
`);
